import { useI18n } from '@cvo/i18n/composables/useI18n';
import type { Duration } from 'date-fns';

const DISPLAY_UNITS = ['days', 'hours', 'minutes'] as const;

/**
 * Formats a date-fns Duration as short localized parts (e.g. "2d 14h"),
 * dropping zero units. Only days, hours and minutes are rendered.
 */
export function useDurationFormatter() {
  const { t } = useI18n();

  function formatDuration(duration: Duration): string {
    return DISPLAY_UNITS
      .map(unit => ({ unit, value: duration[unit] ?? 0 }))
      .filter(({ value }) => value > 0)
      .map(({ unit, value }) => t(`ui.date.duration.${unit}.short`, { count: value }))
      .join(' ');
  }

  return { formatDuration };
}
